import { useEffect, useState } from 'react';
import { useMachine } from '@xstate/react';
import ChargerModule from '../../../components/chargerModule';
import PlusButton from '../../../assets/images/searchBar/plusButton';
import BlogPostListingCard from './Components/BlogPostListingCard';
import './BlogListing.scss';
import { blogListMachine } from './BlogListing.controller';
import UnsuccessfulSearch from '../../../components/unsuccessfulSearch';
import BlogPostSkeletonCard from './Components/BlogPostSkeletonCard';
import { getBlogList } from '../../../services/blog';
import { IblogPostListingCardData } from '../../../types/blog';
import useDebounce from '../../../hooks/useDebounce';

const BlogListing = () => {
  const [stateMachine, send] = useMachine(blogListMachine);
  const [searchText, setSearchText] = useState<string>('');
  const [blogEntries, setBlogEntries] = useState<IblogPostListingCardData[]>();
  const [uploadingCounter, setUploadingCounter] = useState(0);
  const query = useDebounce(searchText, 1500);

  const infoSideBar = { position: 'blog' };
  const headerInfo = { title: 'Blog', subtitle: '' };
  const buttons = [
    {
      title: 'Nuevo',
      route: '/blog/new-entry',
      color: 'orangeButton',
      icon: (
        <div className="iconStyle">
          <PlusButton className="iconPositionButton" />
        </div>
      )
    }
  ];

  const getBlogEntries = async () => {
    try {
      const response = await getBlogList(query);
      if (response.length > 0) {
        setBlogEntries(response);
        send('RESOLVE');
      }
      if (response.length === 0 && !!query) send('FAIL_SEARCH');
      if (response.length === 0 && !query) send('EMPTY_RESPONSE');
    } catch (error) {
      send('REJECT');
    }
  };

  useEffect(() => {
    send('DATA_CHANGE');
    getBlogEntries();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query, uploadingCounter]);

  return (
    <ChargerModule
      infoSideBar={infoSideBar}
      headerInfo={headerInfo}
      buttons={buttons}
      viewSearchBar
      searchText={searchText}
      setSearchText={setSearchText}
    >
      <div id="blogListing">
        <div className="headerTitles">
          <div className="thumb">THUMB</div>
          <div className="title">TÍTULO</div>
          <div className="category">CATEGORÍA</div>
          <div className="date">FECHA</div>
          <div className="author">AUTOR</div>
        </div>
        {stateMachine.matches('pending') && (
          <div className="listing">
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(i => {
              return <BlogPostSkeletonCard key={`skelleton-card-${i}`} />;
            })}
          </div>
        )}
        {stateMachine.matches('resolved') && blogEntries && (
          <div className="listing">
            {!!blogEntries &&
              blogEntries.length > 0 &&
              blogEntries.map((blogEntry, i) => {
                return (
                  <BlogPostListingCard
                    key={`blogEntry${blogEntry.postId}-${i}`}
                    blogEntry={blogEntry}
                    setUploadingCounter={setUploadingCounter}
                    uploadingCounter={uploadingCounter}
                  />
                );
              })}
          </div>
        )}
        {stateMachine.matches('unsuccessfulSearch') && <UnsuccessfulSearch />}
        {stateMachine.matches('emptyResponse') && (
          <div className="noPublications">Aún no tienes publicaciones en el blog Nudos</div>
        )}
        {stateMachine.matches('rejected') && (
          <div className="fetchError">
            Error cargando los datos, intenta nuevamente, si el problema persiste consulta a soporte
          </div>
        )}
      </div>
    </ChargerModule>
  );
};

export default BlogListing;
